import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Dashboard() {
  const { user, logout } = useAuth();

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.logo}>DevInfotec</h1>
        <div style={styles.userInfo}>
          <span>Bonjour, {user?.username}</span>
          <button style={styles.logoutBtn} onClick={logout}>Déconnexion</button>
        </div>
      </header>
      <main style={styles.main}>
        <h2 style={styles.welcome}>Tableau de bord</h2>
        <p style={styles.subtitle}>Bienvenue sur DevInfotec</p>
      </main>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: '#f0f2f5' },
  header: {
    background: '#1a237e',
    color: '#fff',
    padding: '0 24px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: { fontSize: '20px', margin: 0 },
  userInfo: { display: 'flex', alignItems: 'center', gap: '16px', fontSize: '14px' },
  logoutBtn: {
    background: 'rgba(255,255,255,0.2)',
    color: '#fff',
    border: '1px solid rgba(255,255,255,0.4)',
    padding: '6px 14px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '13px',
  },
  main: { padding: '40px 24px' },
  welcome: { color: '#1a237e', marginBottom: '8px' },
  subtitle: { color: '#666' },
};
